export default __webpack_public_path__ + "static/media/AmazonReplica.bd2ff190.png";